module.exports = __webpack_public_path__ + "img/blacks_wanted_poster.1b093d02.jpg";